// hooks/useTokenValidation.ts
import { useEffect, useState } from "react";
import { validateToken } from "../../components/Globais";

// 🔐 Tipos de permissão possíveis
type NivelPermissao = "ADM" | "OPE" | "USU";

export const usePermissao = (nivelRequerido: NivelPermissao) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isValid, setIsValid] = useState<boolean>(false);

  useEffect(() => {
    const verificarPermissao = () => {
      const Token = validateToken();
      if (!Token) {
        document.location.href = "/login"; // Redireciona se não houver token
        setIsValid(false);
        setIsLoading(false);
        return;
      } 
      
      // 🔸 2. Verifica NDA do token
      const { nda } = Token;

      let permitido = false;

       switch (nivelRequerido) {
        case "ADM":
          permitido = nda === 1;
          break;
        case "OPE":
          permitido = nda === 1 || nda === 2;
          break;
        case "USU":
          permitido = nda === 0 || nda === 1 || nda === 2;
          break;
        default:
          permitido = false;
      }

     

      if (!permitido) {
        
        
        document.location.href = "/sempermissao";
        setIsValid(false);
      } else {
        setIsValid(true);
      }

      setIsLoading(false);

      
      
     
    };

    verificarPermissao();
  }, [nivelRequerido]);

  return { isLoading, isValid };
};
